module.exports = __webpack_public_path__ + "static/media/css_logo.ca096e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tech_logos/css_logo.png
// module id = 81
// module chunks = 0